import React, {useEffect, useState} from "react";

interface DecimalInputProps {
    label: string;
    value: number;
    onChange: (value: number) => void;
    onBlur?: (value: number) => void;
    className?: string;
    style?: React.CSSProperties;
    placeholder?: string;
    isRequired?: boolean;
}

// Keep digits and a single decimal separator; treat comma as dot (RU/KZ keyboards).
function sanitizeDecimal(raw: string): string {
    let s = raw.replace(",", ".").replace(/[^\d.]/g, "")
    const dot = s.indexOf(".")
    if (dot !== -1) {
        s = s.slice(0, dot + 1) + s.slice(dot + 1).replace(/\./g, "")
    }
    return s
}

function toNumber(s: string): number {
    if (s === "" || s === ".") return 0
    const n = Number(s)
    return Number.isNaN(n) ? 0 : n
}

export function DecimalInput(props: DecimalInputProps) {
    const [text, setText] = useState<string>(() => props.value.toString())

    // Re-sync display when value changes externally (item switch, parent clamp),
    // without clobbering an in-progress entry like "1." that already parses to props.value.
    useEffect(() => {
        if (toNumber(text) !== props.value) {
            setText(props.value.toString())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value])

    return (
        <div className="control">
            <div className="control__label">
                {props.label}
                {props.isRequired && <span className="required-star">*</span>}
            </div>
            <input className="control__input" inputMode="decimal" step="any"
                   placeholder={props.placeholder}
                   value={text}
                   style={props.style}
                   onChange={(e) => {
                       const cleaned = sanitizeDecimal(e.currentTarget.value)
                       setText(cleaned)
                       props.onChange(toNumber(cleaned))
                   }}
                   onBlur={() => {
                       setText(props.value.toString()) // normalize "1." -> "1", "1.50" -> "1.5"
                       if (props.onBlur) {
                           props.onBlur(props.value)
                       }
                   }}
            />
        </div>
    )
}
